import { __assign, __decorate, __extends } from "tslib";
import React from 'react';
import { locale } from '@skbkontur/react-ui/lib/locale/decorators';
import { TopBarButtonItem } from './TopBarButtonItem';
import { TopBarLocaleHelper } from './locale';
/**
 * Кнопка выхода
 *
 * @visibleName TopBar.Logout
 */

var TopBarLogout =
/** @class */
function (_super) {
  __extends(TopBarLogout, _super);

  function TopBarLogout() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  TopBarLogout.prototype.render = function () {
    return React.createElement(TopBarButtonItem, __assign({}, this.props), this.props.children || this.locale.logout);
  };

  TopBarLogout.__KONTUR_REACT_UI__ = 'TopBarLogout';
  TopBarLogout.defaultProps = TopBarButtonItem.defaultProps;
  TopBarLogout = __decorate([locale('TopBar', TopBarLocaleHelper)], TopBarLogout);
  return TopBarLogout;
}(React.Component);

export { TopBarLogout };